export default __webpack_public_path__ + "static/media/product5.a9c4c391.jpg";